import React, { useRef } from 'react';

import amplitude from 'amplitude-js';
import { sendBrazeEvent } from 'apps/auth/analytics/braze';
import { DiskBadge } from 'apps/auth/components/common/DiskBadge/DiskBadge';
import { DiskButton } from 'apps/auth/components/common/DiskButton/DiskButton';
import { Panel } from 'apps/auth/components/common/Panel/Panel';
import { DiskBadgeWrapper, PanelContent, PanelRightBlock, PanelRow } from 'apps/auth/components/common/Panel/styles';
import PopupButton from 'apps/auth/components/common/Popup/PopupButton';
import PopupNew from 'apps/auth/components/common/Popup/PopupNew';
import SimplePopup from 'apps/auth/components/common/Popup/SimplePopup';
import { Text } from 'apps/auth/components/common/Text/Text';
import { DISABLED_METHOD_CLICKED, METHOD_UNAVAILABLE_SHOWN } from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { PAYMENT_COUNTRY, PAYMENT_METHOD_TYPE, PAYOUT_COUNTRY } from 'apps/auth/constants/amplitude/AmplitudeParamName';
import { DELIVERY } from 'apps/auth/constants/amplitude/AmplitudeParamValues';
import { BR_TEMP_UNAVAILABLE_PROV_SELECTED } from 'apps/auth/constants/braze/brazeEvents';
import { BR_PROVIDER_ID } from 'apps/auth/constants/braze/brazeParams';
import { useExtra, usePageMessages } from 'apps/auth/hooks/selectors';
import { MarkdownService } from 'apps/auth/services/MarkdownService';

import { deliveryIcon, getHref } from './deliveryMethodUtils';

const DisabledCompactDeliveryMethod = (props) => {
    const { pocket, toCountry, toCurrency, userCountry } = useExtra();
    const { gotIt } = usePageMessages();
    const pocketId = pocket?.id;
    const toCurrencyCode = toCurrency?.code || props.countrySource?.currencyCode;
    const toCountryCode = toCountry?.code;
    const href = getHref(props.deliveryMethod, toCountryCode, toCurrencyCode, pocketId, props.isGA, props.isBonus);
    const popupRef = useRef(null);

    const clickHandler = (e) => {
        e.preventDefault();
        sendBrazeEvent(BR_TEMP_UNAVAILABLE_PROV_SELECTED, {
            [BR_PROVIDER_ID]: props.countrySource?.prvId,
        });
        amplitude.getInstance().logEvent(DISABLED_METHOD_CLICKED, {
            [PAYMENT_COUNTRY]: userCountry?.nameEn,
            [PAYOUT_COUNTRY]: toCountry?.nameEn,
        });
        amplitude.getInstance().logEvent(METHOD_UNAVAILABLE_SHOWN, {
            [PAYMENT_COUNTRY]: userCountry?.nameEn,
            [PAYOUT_COUNTRY]: toCountry?.nameEn,
            [PAYMENT_METHOD_TYPE]: DELIVERY,
        });
        popupRef.current?.open(
            <SimplePopup text={MarkdownService.splitByParagraph(props.temporarilyUnavailableReason)} popupRef={popupRef}>
                <PopupButton
                    iconName="check"
                    text={gotIt}
                    onClick={() => {
                        popupRef.current?.close();
                    }}
                />
            </SimplePopup>,
        );
    };

    return (
        <li>
            <Panel type="reactLink" onClick={clickHandler} to={href} isHoverable negativeMargin>
                <DiskBadgeWrapper>
                    <DiskBadge variant="secondary" withoutRadius={true} iconName={deliveryIcon(props.deliveryMethod, toCountryCode)} isInactive />
                </DiskBadgeWrapper>
                <PanelContent>
                    <PanelRow>
                        <Text color="lightGray">{props.countrySource.title}</Text>
                    </PanelRow>
                    {props.countrySource.subtitle && (
                        <PanelRow>
                            <Text size="secondary" color="lightGray">
                                {props.countrySource.subtitle}
                            </Text>
                        </PanelRow>
                    )}
                </PanelContent>
                <PanelRightBlock>
                    <DiskButton type="button" variant="tertiary" size="small" iconName="info-rounded" iconColor="lightGray" raised={false} />
                </PanelRightBlock>
            </Panel>
            <PopupNew ref={popupRef} />
        </li>
    );
};

export default DisabledCompactDeliveryMethod;
